import CryptoJS from 'crypto-js';
const password = btoa('yb2025');
export default {
    encrypt(plaintext) {
        return  CryptoJS.AES.encrypt(plaintext, password).toString();
    },
    decrypt(plaintext) {
        const bytes = CryptoJS.AES.decrypt(plaintext, password);
        return  bytes.toString(CryptoJS.enc.Utf8);
    }
}